export const GET_DATA = "GET_DATA_DATATABLE";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAIL = "GET_DATA_FAIL";

export const CLEAR_DATA = "CLEAR_DATA";
export const CLEAR_DATA_SUCCESS = "CLEAR_DATA_SUCCESS";

export const SET_PAGE = "SET_PAGE";
